import { authenticatedPatch } from '../../../../../api/utils/request';

export default async function saveCompleteAppointment(saveData, setErrorMessage) {
    const onFail = () => setErrorMessage('Ocurrió un error guardando la actualización de la cita.');
    const url = '/appointment-management/complete-appointment';
    return await authenticatedPatch(url, onFail, saveData);
}
